module.exports = __webpack_public_path__ + "static/img/arrowRightIcon.185a519c.svg";